import { createContext, useState } from 'react';

//create a context, with createContext api
export const menuDetailsContext = createContext();

const MenuDetailsProvider = (props) => {

    // this state will be shared with all components 
    const [menuDetails, setMenuDetails] = useState("SPY");

    // User State
    const [lcoin, setLcoin] = useState("");
    const [gname, setGname] = useState("");
    const [gpicture, setGpicture] = useState("");
    const [gemail, setGemail] = useState("");
    const [shoppingCart, setShoppingCart] = useState({});

    return (
        <menuDetailsContext.Provider
          value={[
            menuDetails,
            setMenuDetails,

            lcoin,
            setLcoin,

            gname,
            setGname,

            gpicture,
            setGpicture,

            gemail,
            setGemail,

            shoppingCart,
            setShoppingCart,
          ]}
        >
            {props.children}
        </menuDetailsContext.Provider>
    );
};

export default MenuDetailsProvider;

